module.exports = __webpack_public_path__ + "img/icone-alerta.2b230245.svg";